import { useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import InstructorSidebar from "../common/instructorSidebar";
import { changePasswordApi } from "utils/authThunk";

const ChangePassword = () => {
  const dispatch = useDispatch();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("New and confirm passwords do not match");
      return;
    }

    const result = await dispatch(
      changePasswordApi({ currentPassword, newPassword })
    );

    if (result?.payload?.success) {
      toast.success(result?.payload?.message || "Password changed successfully");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } else {
      toast.error(result?.payload?.message || "Failed to change password");
    }
  };

  return (
    <>
      <Breadcrumb title="Change Password" />
      <div className="content">
        <div className="container" >
          <div className="row">
            <InstructorSidebar />
            <div className="col-lg-9">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Change Password</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Current Password</label>
                      <div className="position-relative">
                        <input
                          type={showCurrent ? "text" : "password"}
                          className="form-control"
                          value={currentPassword}
                          onChange={(e) => setCurrentPassword(e.target.value)}
                        />
                        <span
                          onClick={() => setShowCurrent((prev) => !prev)}
                          className={`isax ${
                            showCurrent ? "isax-eye" : "isax-eye-slash"
                          } position-absolute top-50 end-0 translate-middle-y me-3 text-muted cursor-pointer`}
                          style={{ cursor: "pointer" }}
                        ></span>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">New Password</label>
                      <div className="position-relative">
                        <input
                          type={showNew ? "text" : "password"}
                          className="form-control"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <span
                          onClick={() => setShowNew((prev) => !prev)}
                          className={`isax ${
                            showNew ? "isax-eye" : "isax-eye-slash"
                          } position-absolute top-50 end-0 translate-middle-y me-3 text-muted cursor-pointer`}
                          style={{ cursor: "pointer" }}
                        ></span>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Confirm Password</label>
                      <div className="position-relative">
                        <input
                          type={showConfirm ? "text" : "password"}
                          className="form-control"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <span
                          onClick={() => setShowConfirm((prev) => !prev)}
                          className={`isax ${
                            showConfirm ? "isax-eye" : "isax-eye-slash"
                          } position-absolute top-50 end-0 translate-middle-y me-3 text-muted cursor-pointer`}
                          style={{ cursor: "pointer" }}
                        ></span>
                      </div>
                    </div>

                    <div className="d-grid">
                      <button className="btn btn-primary" type="submit">
                        Update Password
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
